import { ArrowDown } from "@phosphor-icons/react";

export default function SectionPrompt({ text, icon = null, testId }) {
  return (
    <div
      data-testid={testId || "section-prompt"}
      className="relative bg-[#FAFAFA] py-6 md:py-8"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-center gap-3">
        <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent to-zinc-200" />
        <span className="inline-flex items-center gap-2 text-sm md:text-base font-semibold text-zinc-700">
          {icon}
          <span className="gradient-text">{text}</span>
          <ArrowDown size={14} weight="bold" className="text-zinc-400" />
        </span>
        <span className="h-px flex-1 max-w-[120px] bg-gradient-to-l from-transparent to-zinc-200" />
      </div>
    </div>
  );
}
